export function validateEmail(email: string): boolean {
  const reg = /\S+@\S+\.\S+/;
  return reg.test(email);
}

export const toI18nParams = (params: unknown[] = []) => {
  const m: Record<string, string> = {};
  params.forEach((v, i) => {
    m[`p${i}`] = String(v ?? '');
  });
  return m;
};
